// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"237":"bd65f1fe","453":"4c757c4d","962":"080d40fc"}[chunkId] + ".chunk.js");